// src/components/Nav.js
import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";

export default function Nav() {
  const { user, profile, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    toast.success("Logged out successfully");
    navigate("/");
  };

  const active = (path) => location.pathname === path;

  return (
    <nav style={{
      position: "sticky", top: 0, zIndex: 100,
      background: "#fff", borderBottom: "1px solid #e2ece2",
      boxShadow: "0 1px 12px rgba(26,107,60,0.07)"
    }}>
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 16px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 60 }}>

        {/* Logo */}
        <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ width: 34, height: 34, background: "#1a6b3c", borderRadius: 9, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ fontSize: 18 }}>🏠</span>
          </div>
          <span style={{ fontFamily: "'Sora', sans-serif", fontWeight: 700, fontSize: 19, color: "#1a6b3c" }}>
            Apna<span style={{ color: "#f59e0b" }}>Satna</span>
          </span>
        </Link>

        {/* Desktop Links */}
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <NavLink to="/properties" label="Buy / Rent" active={active("/properties")} />
          <NavLink to="/add-property" label="+ Sell Free" accent active={active("/add-property")} />

          {user ? (
            <>
              <NavLink to="/dashboard" label="Dashboard" active={active("/dashboard")} />
              {profile?.role === "admin" && (
                <NavLink to="/admin" label="🛡️ Admin" active={active("/admin")} />
              )}
              <button onClick={handleLogout} style={{
                padding: "7px 14px", borderRadius: 8, border: "1px solid #e2ece2",
                background: "white", color: "#6b7c6b", fontSize: 13, fontWeight: 600,
                cursor: "pointer", fontFamily: "inherit"
              }}>Logout</button>
              <Link to="/dashboard" style={{ textDecoration: "none" }}>
                <div style={{
                  width: 34, height: 34, borderRadius: 17, background: "#1a6b3c",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  color: "white", fontWeight: 700, fontSize: 14
                }}>
                  {(profile?.name || user.email || "U")[0].toUpperCase()}
                </div>
              </Link>
            </>
          ) : (
            <>
              <NavLink to="/login" label="Login" active={active("/login")} />
              <Link to="/register" style={{
                padding: "8px 16px", borderRadius: 8, background: "#1a6b3c",
                color: "white", fontWeight: 700, fontSize: 13, textDecoration: "none"
              }}>Register</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

function NavLink({ to, label, active, accent }) {
  return (
    <Link to={to} style={{
      padding: "7px 13px", borderRadius: 8, textDecoration: "none",
      background: accent ? "#f59e0b" : active ? "#1a6b3c" : "white",
      color: accent ? "white" : active ? "white" : "#1a2e1a",
      border: accent || active ? "none" : "1px solid #e2ece2",
      fontWeight: 600, fontSize: 13
    }}>{label}</Link>
  );
}
